import { Injectable, signal } from '@angular/core';
import { ApplicationName } from '../interfaces/common.interface';

export type EnvironmentLink = {
  [key in ApplicationName]: string;
};

export type EnvironmentVariables = {
  production?: boolean;
  apiURL: string;
  graphQLURL: string;
  links: EnvironmentLink;
  sso?: {
    url: string;
    clientId: string;
  };
  mapbox?: {
    accessToken: string;
    legacyMapBoxStyleUrl: string;
    darkMapBoxStyleUrl: string;
    /**
     * URL of mapbox's standalone `mapbox-gl-csp-worker.js`, resolved against the document base.
     * Defaults to `assets/mapbox-gl/mapbox-gl-csp-worker.js` (see `MapService`).
     */
    workerUrl?: string;
  };
  pusher?: {
    enabled: boolean;
    key: string;
    host: string;
    port: number;
    tlsPort: number;
    forceTLS: boolean;
    authEndpoint: string;
    presenceAuthEndpoint?: string;
  };
  cubeJS?: {
    api?: string;
  };
};

export type GlobalConfig = any;

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  environment: EnvironmentVariables;

  globalConfig = signal<GlobalConfig>(null);

  constructor() {}

  setUpEnvironment<T>(data: T & EnvironmentVariables) {
    this.environment = data;
  }

  updateGlobalConfig(newConfigValues: Partial<GlobalConfig>) {
    this.globalConfig.update((oldConfigValues) => ({
      ...oldConfigValues,
      ...newConfigValues,
    }));
  }
}
